
export const strongTranslationsZH = {
  "G11": {
    m: "亚伯拉罕",
    d: "族长亚伯拉罕，信徒之父。",
    u: "在新约中使用73次。信心的榜样。",
    e: "源自希伯来文אַבְרָהָם（Abraham）= 众人之父"
  },
  "G25": {
    m: "以神圣无条件的爱去爱",
    d: "以无私、牺牲和神圣的爱去爱。这是上帝对人类的爱（约翰福音3:16），也是基督徒应当彼此相爱的方式（约翰福音13:34-35）。与人类的爱不同，这种爱是意志的选择，而非情感。",
    u: "在新约中使用143次。描述神圣、完美和无条件的爱。",
    e: "源自ἄγω（ago）= 引导，导向善"
  },
  "G26": {
    m: "神圣的爱，慈善",
    d: "上帝的完美之爱；兄弟之爱、情感、善意、慈善。这种爱连接上帝与人，以及人与邻舍。",
    u: "在新约中使用116次。基督教中描述神圣之爱的核心词汇。",
    e: "源自ἀγαπάω（agapao）"
  },
  "G27": {
    m: "蒙爱的，亲爱的",
    d: "被爱的，珍爱的；被上帝或人所爱的。",
    u: "在新约中使用61次。上帝的爱子。",
    e: "源自ἀγαπάω（agapao）= 爱"
  },
  "G32": {
    m: "天使，使者",
    d: "使者；服侍上帝的天上使者。",
    u: "在新约中使用175次。上帝的天使。",
    e: "源自ἀγγέλλω（aggello）= 宣告"
  },
  "G36": {
    m: "卑贱的，不体面的",
    d: "没有贵族身份，出身低微；被藐视的。",
    u: "在新约中使用1次（哥林多前书1:28）。",
    e: "源自ἀ-（否定）+ γένος（genos）= 出身"
  },
  "G93": {
    m: "不义，罪恶",
    d: "违反正义，不公；邪恶，道德罪恶。",
    u: "在新约中使用25次。与δικαιοσύνη（公义）相对。",
    e: "源自ἀ-（否定）+ δίκη（dike）= 正义"
  },
  "G154": {
    m: "求，请求，祈求",
    d: "请求，恳求某事，祈求，请愿。谦逊和恭敬的请求。",
    u: "在新约中使用70次。向神或人的请求。",
    e: "来自αἰτέω（aiito）基本词根；请求"
  },
  "G166": {
    m: "永恒的，永久的",
    d: "无始无终，永远存在；在新约中常与上帝里的永生联系。",
    u: "在新约中使用71次。常用于形容永生和上帝的国度。",
    e: "源自αἰών（aion）= 时代，纪元，永恒"
  },
  "G225": {
    m: "真理，实在",
    d: "关于上帝和人的责任的真实事物；启示的神圣真理。",
    u: "在新约中使用109次。耶稣教导的核心概念。",
    e: "源自ἀληθής（alethes）= 真实的，诚实的"
  },
  "G281": {
    m: "阿们，诚然",
    d: "肯定的表达：愿如此，真实，确实。",
    u: "在新约中使用129次。耶稣说'我实在实在告诉你们'。",
    e: "源自希伯来文אָמֵן（amen）= 坚定的，忠实的"
  },
  "G444": {
    m: "人，人类",
    d: "人类，男人或女人；整体的人类。",
    u: "在新约中使用550次。按照上帝形象造的人。",
    e: "源自ἀνήρ（aner）= 男人 + ὤψ（ops）= 脸"
  },
  "G622": {
    m: "失去，毁灭，灭亡",
    d: "完全毁灭；失去，灭亡；被毁坏。",
    u: "在新约中使用90次。拯救失丧的。",
    e: "源自ἀπό（apo）= 从 + ὄλλυμι（ollumi）= 毁灭"
  },
  "G649": {
    m: "差遣，派遣",
    d: "带着使命差遣；作为使者派遣。",
    u: "在新约中使用132次。父差遣子。",
    e: "源自ἀπό（apo）= 从 + στέλλω（stello）= 差遣"
  },
  "G721": {
    m: "羔羊",
    d: "小羊羔；指耶稣基督为上帝的羔羊。",
    u: "在新约中使用30次，主要在启示录中。",
    e: "ἀρήν（aren）= 羔羊的小称"
  },
  "G730": {
    m: "男性的，雄性的",
    d: "男性性别，雄性。",
    u: "在新约中使用9次。上帝造人有男有女。",
    e: "基本词根"
  },
  "G740": {
    m: "面包",
    d: "面包，食物；生命的粮 = 基督。",
    u: "在新约中使用97次。耶稣是生命的粮。",
    e: "源自ἄρω（aro）= 举起，提升"
  },
  "G746": {
    m: "起初，源头",
    d: "起初，起源，第一原理。在约翰福音1:1-2中，指道（逻各斯）已经存在的永恒起初。",
    u: "在新约中使用55次。约翰福音1:1的关键词'太初有道'。",
    e: "原始词汇；起初，第一源头"
  },
  "G772": {
    m: "软弱的，患病的",
    d: "无力的，软弱的；生病的，虚弱的；属灵上软弱的。",
    u: "在新约中使用25次。上帝拣选世上软弱的。",
    e: "源自ἀ-（否定）+ σθένος（sthenos）= 力量"
  },
  "G907": {
    m: "施洗，浸入",
    d: "浸入水中；施洗以洁净或入教。",
    u: "在新约中使用77次。基督教洗礼。",
    e: "源自βάπτω（bapto）= 浸入，沉入"
  },
  "G1080": {
    m: "生，使诞生",
    d: "生育，生产；属灵上重生。",
    u: "在新约中使用97次。从上帝生的，重生。",
    e: "基本词根"
  },
  "G1096": {
    m: "成为，发生，产生",
    d: "成为，存在，发生，出现，产生。",
    u: "在新约中使用678次。'万物是借着他造的'（约1:3）。",
    e: "源自γίνομαι（ginomai）= 成为"
  },
  "G1097": {
    m: "认识，知道，理解",
    d: "通过个人经验认识；理解，感知，意识到。",
    u: "在新约中使用222次。经验性的认识，不仅仅是智力上的。",
    e: "印欧语系词根*gen- = 产生，认识"
  },
  "G1100": {
    m: "舌头，语言",
    d: "说话的器官；语言，方言；说方言的恩赐。",
    u: "在新约中使用50次。说方言的恩赐。",
    e: "基本词根"
  },
  "G1166": {
    m: "显示，证明",
    d: "展示在眼前，显示；证明，论证。",
    u: "在新约中使用33次。上帝显示他的荣耀。",
    e: "基本词根"
  },
  "G1208": {
    m: "第二的，次要的",
    d: "序列或次序中的第二。",
    u: "在新约中使用44次。第二条诫命。",
    e: "源自δύο（duo）= 二"
  },
  "G1271": {
    m: "理智，思想",
    d: "思考、听、理解的能力；心智，理解力。",
    u: "在新约中使用12次。被基督更新的心志。",
    e: "源自διά（dia）= 通过 + νοῦς（nous）= 心智"
  },
  "G1320": {
    m: "老师，师傅，教师",
    d: "老师，教师；教导宗教真理的人。",
    u: "在新约中使用59次。'拉比，我们知道你是由神那里来作师傅的'（约3:2）。",
    e: "源自διδάσκω（didasko）= 教导"
  },
  "G1325": {
    m: "给予，授予",
    d: "给某人某物；授予，允许；交付。",
    u: "在新约中使用415次。上帝慷慨地给予。",
    e: "基本词根"
  },
  "G1372": {
    m: "口渴，渴望",
    d: "受口渴之苦；热切渴望，渴慕。",
    u: "在新约中使用16次。对上帝的属灵渴慕。",
    e: "源自δίψα（dipsa）= 口渴"
  },
  "G1401": {
    m: "奴隶，仆人",
    d: "奴隶，仆人；自愿的上帝仆人。",
    u: "在新约中使用124次。基督的仆人。",
    e: "源自δέω（deo）= 捆绑"
  },
  "G1411": {
    m: "能力，力量，神迹",
    d: "力量，权能，能力；大能的作为，神迹。",
    u: "在新约中使用120次。上帝的能力，圣灵的能力。",
    e: "源自δύναμαι（dunamai）= 能够"
  },
  "G1417": {
    m: "二",
    d: "数字二；一对。",
    u: "在新约中使用135次。两三个见证人。",
    e: "基本词根"
  },
  "G1473": {
    m: "我",
    d: "第一人称单数人称代词。",
    u: "在新约中使用2567次。非常常用。",
    e: "基本代词"
  },
  "G1484": {
    m: "民族，国家，外邦人",
    d: "民族，国家；外邦民族（非犹太人）。",
    u: "在新约中使用162次。福音传给万国万民。",
    e: "基本词根"
  },
  "G1492": {
    m: "知道，看见，明白",
    d: "通过感知知道，看见，理解，认识。通过经验或启示获得的知识。",
    u: "在新约中使用666次。约翰福音中知识的基本动词。",
    e: "εἴδω（eido）的完成时；看见，知道"
  },
  "G1510": {
    m: "是，存在",
    d: "动词'是'的所有意义；存在，持续，发生。",
    u: "新约中最常用的动词（2460+次）。",
    e: "基本词根"
  },
  "G1515": {
    m: "平安",
    d: "宁静的状态；与上帝和好；人与人之间的和谐。",
    u: "在新约中使用92次。基督的平安。",
    e: "源自εἴρω（eiro）= 连接，捆绑"
  },
  "G1520": {
    m: "一个，独一的",
    d: "一个；独一的，唯一的；某一个。",
    u: "在新约中使用344次。上帝的合一，教会的合一。",
    e: "基本词根"
  },
  "G1586": {
    m: "拣选，选择",
    d: "为自己选择，挑选；因神的恩典被拣选。",
    u: "在新约中使用21次。上帝拣选他的儿女。",
    e: "源自ἐκ（ek）= 从中 + λέγω（lego）= 选择"
  },
  "G1658": {
    m: "自由的，得释放的",
    d: "自由的，非奴隶的；从罪的奴役中得释放。",
    u: "在新约中使用23次。在基督里得自由。",
    e: "可能源自ἔρχομαι（erchomai）= 来"
  },
  "G1672": {
    m: "希腊人，外邦人",
    d: "出生或语言上的希腊人；非犹太人。",
    u: "在新约中使用25次。在基督里无分犹太人或希腊人。",
    e: "源自Ἑλλάς（Hellas）= 希腊"
  },
  "G1680": {
    m: "盼望，信心的期待",
    d: "期待美好事物的心态，建立在上帝基础上的希望；基于神圣应许对未来的信心。",
    u: "在新约中使用54次。与信心和爱并列的三大属灵美德之一。",
    e: "源自ἔλπω（elpo）= 等待，盼望"
  },
  "G1743": {
    m: "加力，使强壮",
    d: "使强壮，加力；赋予能力。",
    u: "在新约中使用8次。上帝加力量给信徒。",
    e: "源自ἐν（en）= 在内 + δυναμόω（dynamoo）= 使有能力"
  },
  "G1746": {
    m: "穿上，披戴",
    d: "穿上衣服；披戴品质或能力。",
    u: "在新约中使用27次。披戴基督，穿上上帝的全副军装。",
    e: "源自ἐν（en）= 在内 + δύω（duo）= 进入，穿上"
  },
  "G1785": {
    m: "诫命，命令",
    d: "命令，诫命，训令；特别是神圣的诫命。",
    u: "在新约中使用67次。上帝和基督的诫命。",
    e: "源自ἐντέλλομαι（entellomai）= 命令"
  },
  "G1848": {
    m: "藐视，轻看",
    d: "视为无物，藐视；轻蔑对待。",
    u: "在新约中使用11次。世界藐视上帝所拣选的。",
    e: "源自ἐξ（ex）= 出自 + οὐθείς（outheis）= 无人"
  },
  "G2041": {
    m: "工作，行为，作为",
    d: "工作，劳作；行动，行为；完成的工作。",
    u: "在新约中使用169次。上帝的工作，好行为。",
    e: "源自ἔργω（ergo）= 工作"
  },
  "G2048": {
    m: "旷野，荒凉的",
    d: "荒凉之地，旷野；孤独的，荒废的。",
    u: "在新约中使用48次。耶稣在旷野四十天。",
    e: "源自ἔρημος（eremos）= 被遗弃的"
  },
  "G2065": {
    m: "问，询问，查问",
    d: "问，询问，查问以获得信息。调查或询问。",
    u: "在新约中使用63次。询问以获得答案。",
    e: "不确定词根；问，询问"
  },
  "G2189": {
    m: "仇恨，敌意",
    d: "仇恨，敌意，仇视。",
    u: "在新约中使用6次。与上帝的仇恨已废除。",
    e: "源自ἐχθρός（echthros）= 仇敌"
  },
  "G2205": {
    m: "热心，嫉妒，羡慕",
    d: "热情的激情；可以是积极的（为上帝热心）或消极的（嫉妒、羡慕）。",
    u: "在新约中使用16次。根据上下文可以是美德或恶习。",
    e: "源自ζέω（zeo）= 沸腾，热烈"
  },
  "G2222": {
    m: "生命",
    d: "肉体或属灵的生命；在上帝里的永生。",
    u: "在新约中使用135次。耶稣是生命。",
    e: "源自ζάω（zao）= 活着"
  },
  "G2258": {
    m: "是，他是",
    d: "是，他是，她是。动词是（εἰμί）的未完成时形式。表达过去的状态或存在。",
    u: "在新约中使用267次。在约翰福音1:1'太初有道'中至关重要。",
    e: "εἰμί（eimi）的未完成时 = 是；是"
  },
  "G2296": {
    m: "惊奇，惊叹，赞美",
    d: "惊奇，惊叹，惊讶，赞美。对非凡事物的惊奇反应。",
    u: "在新约中使用43次。对耶稣神迹和教导的频繁反应。",
    e: "来自θαῦμα（thauma）= 奇迹；惊奇"
  },
  "G2316": {
    m: "上帝，神明",
    d: "独一真神，至高永恒的存在。在新约中指父上帝，或耶稣基督圣子，或圣灵 - 圣三一。",
    u: "在新约中使用1343次。在三一一体中指称独一真神的基本词汇。",
    e: "据斯特朗词典词源不确定。指神明，特别是至高神性。圣经用法：启示在救赎历史中作工的永活神。"
  },
  "G2338": {
    m: "女性的，雌性的",
    d: "女性性别，雌性。",
    u: "在新约中使用5次。男女在基督里平等。",
    e: "源自θηλάζω（thelazo）= 哺乳"
  },
  "G2362": {
    m: "宝座",
    d: "王座，宝座；王权和权柄。",
    u: "在新约中使用62次。上帝和羔羊的宝座。",
    e: "基本词根"
  },
  "G2381": {
    m: "多马",
    d: "多马，专有名词。十二使徒之一，也叫低土马（双胞胎）。以要求复活证据而闻名。",
    u: "在新约中使用11次。疑惑后相信的使徒。",
    e: "来自亚拉姆语תְּאוֹמָא（teoma）= 双胞胎"
  },
  "G2398": {
    m: "自己的，特别的，个人的",
    d: "自己的，特别的，个人的，私人的。特别属于某人的，与他人不同的。",
    u: "在新约中使用114次。个人所有权和区别的概念。",
    e: "来自不确定词根；自己的，特别的"
  },
  "G2424": {
    m: "耶稣",
    d: "拿撒勒的耶稣，弥赛亚，救主。",
    u: "在新约中使用917次。超乎万名之上的名。",
    e: "源自希伯来文יְהוֹשֻׁעַ（Yehoshua）= 耶和华拯救"
  },
  "G2453": {
    m: "犹太人，犹太的",
    d: "属于犹太民族的；犹太地的居民。",
    u: "在新约中使用195次。犹太人，上帝拣选的民族。",
    e: "源自Ἰούδας（Ioudas）= 犹大"
  },
  "G2491": {
    m: "约翰",
    d: "约翰，专有名词。施洗约翰先驱，使徒约翰，福音书和书信的作者。",
    u: "在新约中使用135次。新约两大人物的名字。",
    e: "来自希伯来语יוֹחָנָן（约哈南）= 耶和华恩慈"
  },
  "G2531": {
    m: "如同，照着",
    d: "如同，以同样的方式；照着，按照。",
    u: "在新约中使用182次。比较连词。",
    e: "源自κατά（kata）= 按照 + ὡς（hos）= 如同"
  },
  "G2537": {
    m: "新的，新近的",
    d: "在时间或质量上新的；新鲜的，最近的，未用过的。",
    u: "在新约中使用42次。新造的人，新诫命。",
    e: "词根不确定"
  },
  "G2570": {
    m: "好的，美的",
    d: "本性好的，美丽的；光荣的，卓越的，有德的。",
    u: "在新约中使用100次。好牧人，好行为。",
    e: "基本词根"
  },
  "G2588": {
    m: "心",
    d: "生理的心脏；内在生命的中心，灵魂，精神；思想和感情。",
    u: "在新约中使用156次。属灵生命的所在。",
    e: "基本词根"
  },
  "G2596": {
    m: "按照，反对，通过",
    d: "有多重意义的介词：按照，符合；反对；通过。",
    u: "在新约中使用超过470次。非常常用的介词。",
    e: "基本介词"
  },
  "G2617": {
    m: "使蒙羞，羞辱",
    d: "使蒙羞，羞辱；使困惑，使谦卑。",
    u: "在新约中使用13次。上帝使世上的智慧人羞愧。",
    e: "源自κατά（kata）= 反对 + αἰσχύνω（aischuno）= 羞愧"
  },
  "G2744": {
    m: "夸口，自夸",
    d: "自夸，夸口；以某事为荣。",
    u: "在新约中使用37次。在主里夸口。",
    e: "源自καῦχος（kauchos）= 夸耀"
  },
  "G2889": {
    m: "世界，宇宙，人类",
    d: "世界的秩序，宇宙；堕落的人类；与上帝对立的系统。",
    u: "在新约中使用186次。可指创造物或罪恶的系统。",
    e: "源自κοσμέω（kosmeo）= 装饰，安排"
  },
  "G2919": {
    m: "审判，决定",
    d: "审判，宣告判决；决定，确定。",
    u: "在新约中使用114次。上帝审判世界。",
    e: "基本词根"
  },
  "G2920": {
    m: "审判，公义，定罪",
    d: "审判，公义，定罪，司法决定。神的审判，公正和完美的。",
    u: "在新约中使用47次。神圣公义的核心概念。",
    e: "来自κρίνω（krino）= 审判，决定"
  },
  "G2962": {
    m: "主，主人，所有者",
    d: "主，主人；尊敬和神圣权威的称号；耶稣作为主。",
    u: "在新约中使用748次。'多马对他说：主啊，我们不知道你往哪里去'（约14:5）。",
    e: "源自κύριος（kurios）= 拥有权威"
  },
  "G2992": {
    m: "民族",
    d: "民族，国家；特指上帝的子民（以色列或教会）。",
    u: "在新约中使用142次。上帝拣选的子民。",
    e: "基本词根"
  },
  "G3022": {
    m: "白色的，明亮的",
    d: "白色的，闪耀的；纯洁和胜利的象征。",
    u: "在新约中使用25次。得赎者的白衣。",
    e: "源自λευκός（leukos）= 白色的，发光的"
  },
  "G3056": {
    m: "话语，道，理性",
    d: "说出的话；理性，智慧；道 = 基督。",
    u: "在新约中使用330次。道成肉身。",
    e: "源自λέγω（lego）= 说"
  },
  "G3101": {
    m: "门徒，学生",
    d: "学习者，学生，门徒；耶稣的跟随者。",
    u: "在新约中使用261次。指基督的跟随者。",
    e: "源自μανθάνω（manthano）= 学习"
  },
  "G3141": {
    m: "见证，证词",
    d: "见证，证词，证据，确认。关于真理，特别是关于基督的证词。",
    u: "在新约中使用37次。约翰福音的主要主题。",
    e: "来自μάρτυς（martis）= 见证人"
  },
  "G3173": {
    m: "大的，重要的",
    d: "在大小、数量或重要性上大的；强大的，奇妙的。",
    u: "在新约中使用243次。上帝的伟大。",
    e: "基本词根"
  },
  "G3320": {
    m: "隔断的墙",
    d: "中间隔断的墙，分隔的墙壁。",
    u: "在新约中使用1次（以弗所书2:14）。犹太人与外邦人之间的墙。",
    e: "源自μέσος（mesos）= 中间 + τοῖχος（toichos）= 墙"
  },
  "G3439": {
    m: "独一的，独生的",
    d: "独一无二的，独生的；唯一的儿子。",
    u: "在新约中使用9次。上帝的独生子。",
    e: "源自μόνος（monos）= 唯一 + γίνομαι（ginomai）= 成为"
  },
  "G3474": {
    m: "愚蠢，愚昧",
    d: "愚蠢，荒谬；缺乏智慧的东西。",
    u: "在新约中使用5次。上帝的智慧在世人看来是愚拙的。",
    e: "源自μωρός（moros）= 愚蠢的，无知的"
  },
  "G3475": {
    m: "摩西",
    d: "摩西，以色列的律法颁布者。",
    u: "在新约中使用80次。摩西的律法。",
    e: "源自希伯来文מֹשֶׁה（Mosheh）= 拉出（从水中）"
  },
  "G3530": {
    m: "尼哥底母",
    d: "尼哥底母，专有名词。法利赛人和犹太领袖，夜里来见耶稣。希腊名字，意思是'人民的胜利'。",
    u: "在新约中使用5次。约翰福音中的重要人物。",
    e: "来自希腊语νίκη（nikē）= 胜利和δῆμος（dēmos）= 人民"
  },
  "G3551": {
    m: "律法，摩西五经",
    d: "律法，摩西五经，规则，原则。摩西律法，神圣律法，神的诫命。",
    u: "在新约中使用194次。神圣启示的核心概念。",
    e: "来自νέμω（nemo）= 分配，给予；给定的律法"
  },
  "G3571": {
    m: "夜晚",
    d: "夜晚，日落和日出之间的黑暗时期。常常比喻属灵的无知。",
    u: "在新约中使用61次。在约翰的象征体系中与光形成对比。",
    e: "基本阴性名词；夜晚"
  },
  "G3598": {
    m: "道路，途径",
    d: "路线，道路；生活方式，行为；救恩之路。",
    u: "在新约中使用101次。耶稣是道路。",
    e: "基本词根"
  },
  "G3609": {
    m: "家里的，属家的",
    d: "属于家庭的，家庭成员；家仆。",
    u: "在新约中使用3次。描述上帝家里的人。",
    e: "源自οἶκος（oikos）= 家"
  },
  "G3664": {
    m: "相似的，一样的",
    d: "相似，性质或特征相同；等同的。",
    u: "在新约中使用45次。第二条诫命与第一条相似。",
    e: "源自ὁμός（homos）= 相同"
  },
  "G3686": {
    m: "名字",
    d: "名字，称号；声誉；权柄，能力。",
    u: "在新约中使用228次。耶稣的名。",
    e: "基本词根"
  },
  "G3708": {
    m: "看见，注视",
    d: "用眼睛看；感知，理解；显现。",
    u: "在新约中使用454次。看见基督，看见父。",
    e: "基本词根"
  },
  "G3735": {
    m: "山，山丘",
    d: "山，高山；高地。",
    u: "在新约中使用63次。变像的山。",
    e: "可能源自ὁράω（horao）= 看见"
  },
  "G3756": {
    m: "不，没有",
    d: "绝对否定，不，没有。",
    u: "在新约中使用超过1600次。非常常用的否定词。",
    e: "基本否定词"
  },
  "G3762": {
    m: "没有人，什么都没有，没有",
    d: "没有人，什么都没有，没有，一个也没有。对存在或数量的绝对否定。",
    u: "在新约中使用234次。非常常见的强否定。",
    e: "来自οὐδέ（oude）和εἷς（heis）；连一个也没有"
  },
  "G3778": {
    m: "这，这个，这些",
    d: "指示代词：这，这个，这些。指近处或先前提到的事物。",
    u: "在新约中使用1388次。最常用的指示代词。",
    e: "基本指示代词"
  },
  "G3789": {
    m: "蛇",
    d: "蛇，爬行动物；古蛇（撒但）。",
    u: "在新约中使用14次。旷野中的铜蛇。",
    e: "基本词根"
  },
  "G3793": {
    m: "人群，群众",
    d: "一群人，众人；大众。",
    u: "在新约中使用175次。跟随耶稣的群众。",
    e: "源自ὄχος（ochos）= 车辆（运载）"
  },
  "G3880": {
    m: "接受，拿取，接纳",
    d: "接受，拿取，接纳，抓住。接受所提供或给予的东西。",
    u: "在新约中使用59次。接受福音的核心概念。",
    e: "来自παρά（para）= 旁边和λαμβάνω（lambanō）= 拿取"
  },
  "G3956": {
    m: "一切，每个",
    d: "一切，每个，所有；全部，整体。",
    u: "在新约中使用1244次。最常用的词之一。",
    e: "基本词根"
  },
  "G3962": {
    m: "父亲",
    d: "自然或属灵的父亲；祖先；父上帝。",
    u: "在新约中使用413次。常用于指上帝。",
    e: "基本词根，与拉丁文'pater'相关"
  },
  "G4100": {
    m: "相信，有信心",
    d: "对……有信心，相信；信靠，依靠。",
    u: "在新约中使用241次。信耶稣得救。",
    e: "源自πίστις（pistis）= 信心"
  },
  "G4102": {
    m: "信仰，信心，忠诚",
    d: "对任何真理的确信，信念；在新约中指对人与上帝以及神圣事物关系的确信。",
    u: "在新约中使用244次。基督教信仰的核心概念。",
    e: "源自πείθω（peitho）= 说服，使确信"
  },
  "G4138": {
    m: "丰满，丰富，充满的",
    d: "丰满，丰富，完全充满的。整体性，神圣的完全。",
    u: "在新约中使用17次。基督里神圣丰满的神学概念。",
    e: "来自πλήρης（plērēs）= 满的；丰满"
  },
  "G4139": {
    m: "邻舍，邻居",
    d: "靠近的人，邻居；一般意义上的邻舍。",
    u: "在新约中使用17次。'爱邻舍如同自己'。",
    e: "副词变名词，源自πλησίος（plesios）= 近"
  },
  "G4151": {
    m: "灵，气息，风",
    d: "生命之气，生命原则；理性灵魂；圣灵。",
    u: "在新约中使用385次。指圣灵、人的灵或其他灵体。",
    e: "源自πνέω（pneo）= 吹气，呼吸"
  },
  "G4160": {
    m: "做，制作，完成",
    d: "做，制作，产生，行动，创造。涵盖各种活动的一般行动动词。",
    u: "在新约中使用568次。基本行动动词，常用于神的工作。",
    e: "基本动词；做，完成"
  },
  "G4166": {
    m: "牧羊人，牧者",
    d: "看守羊群的人；属灵的守护者，教会牧师。",
    u: "在新约中使用18次。耶稣是好牧人。",
    e: "源自ποίμνη（poimne）= 羊群"
  },
  "G4183": {
    m: "许多，众多，大的",
    d: "许多，众多，数量或数字上大的。人群，大量。",
    u: "在新约中使用416次。非常常见的数量形容词。",
    e: "不确定词根；许多，众多"
  },
  "G4198": {
    m: "去，走，旅行",
    d: "去，走，旅行，移动。从一地到另一地的移动，常常带有目的。",
    u: "在新约中使用154次。福音书叙事中的基本移动动词。",
    e: "基本动词；去，走"
  },
  "G4238": {
    m: "做，实践，成就",
    d: "做，实践，成就，行动。执行行动，常常带有重复或习惯的概念。",
    u: "在新约中使用39次。常常与善恶的实践相关。",
    e: "πράω（praō）的加强形式；做，实践"
  },
  "G4263": {
    m: "羊，绵羊",
    d: "绵羊或羊；比喻指基督的门徒。",
    u: "在新约中使用39次。信徒如牧人的羊。",
    e: "可能与προβαίνω（probaino）= 前进有关"
  },
  "G4413": {
    m: "第一的，首要的",
    d: "在时间、地点、次序或重要性上第一的。",
    u: "在新约中使用155次。第一条诫命，首位。",
    e: "πρό（pro）= 之前的最高级"
  },
  "G4561": {
    m: "肉体，身体",
    d: "肉，肉体；人的身体；堕落的人性。",
    u: "在新约中使用147次。肉体与圣灵的对比。",
    e: "基本词根"
  },
  "G4592": {
    m: "神迹，奇事，征象",
    d: "神迹，奇事，征象；显明神能的超自然显现。",
    u: "在新约中使用77次。'因为你所行的这些神迹，若不是神同在，无人能行'（约3:2）。",
    e: "源自σημεῖον（semeion）= 记号，标志"
  },
  "G4648": {
    m: "专注观看，瞄准",
    d: "注视，仔细思考；注意目标，瞄准。",
    u: "在新约中使用6次。呼吁定睛注视基督。",
    e: "与σκοπός（skopos）= 目标有关"
  },
  "G4680": {
    m: "智慧的，博学的",
    d: "智慧的，聪明的，熟练的；受过教育的，有学问的。",
    u: "在新约中使用22次。真智慧来自上帝。",
    e: "基本词根"
  },
  "G4982": {
    m: "拯救，搭救",
    d: "从危险或毁灭中拯救；从罪中救赎。",
    u: "在新约中使用106次。耶稣拯救罪人。",
    e: "源自σῶς（sos）= 安全"
  },
  "G5040": {
    m: "小孩子",
    d: "幼儿，小孩；对门徒的亲切称呼。",
    u: "在新约中使用8次。约翰称他的读者为'小子们'。",
    e: "τέκνον（teknon）= 孩子的小称"
  },
  "G5087": {
    m: "放置，设立，建立",
    d: "放，置；设立，任命；存放，摆放。",
    u: "在新约中使用100次。为羊舍命。",
    e: "基本词根"
  },
  "G5109": {
    m: "墙",
    d: "分隔的墙，墙壁。",
    u: "在新约中使用1次（使徒行传23:3）。",
    e: "基本词根"
  },
  "G5207": {
    m: "儿子",
    d: "男性后代；门徒；群体成员。上帝之子 = 耶稣基督。",
    u: "在新约中使用377次。常用于指耶稣为上帝之子。",
    e: "起源不确定，可能与ὕω（huo）= 降雨，生育有关"
  },
  "G5281": {
    m: "忍耐，坚忍，恒心",
    d: "不屈服于环境或压力的品质；耐心的忍耐，恒心。",
    u: "在新约中使用32次。基督徒的基本美德。",
    e: "源自ὑπό（hupo）= 在下 + μένω（meno）= 持续"
  },
  "G5312": {
    m: "举起，高举",
    d: "向上举起，提升；颂扬，尊崇。",
    u: "在新约中使用20次。人子被举起来。",
    e: "源自ὕψος（hupsos）= 高度"
  },
  "G5376": {
    m: "腓力",
    d: "腓力，专有名词。十二使徒之一。希腊名字，意思是'爱马者'。",
    u: "在新约中使用36次。使徒和执事的名字。",
    e: "来自希腊语φίλος（philos）= 朋友和ἵππος（hippos）= 马"
  },
  "G5432": {
    m: "守护，保护",
    d: "用军事守卫守护；保护，保守。",
    u: "在新约中使用4次。上帝的平安守护我们的心。",
    e: "源自φρουρός（phrouros）= 守卫，哨兵"
  },
  "G5443": {
    m: "支派，民族",
    d: "支派，宗族；从共同祖先繁衍的民族。",
    u: "在新约中使用31次。以色列的十二支派。",
    e: "源自φύω（phuo）= 生产，生长"
  },
  "G5457": {
    m: "光",
    d: "物质的或属灵的光；启示的神圣真理。",
    u: "在新约中使用73次。耶稣是世界的光。",
    e: "源自φάω（phao）= 发光"
  },
  "G5463": {
    m: "欢喜，喜乐",
    d: "欢喜，快乐；问候语'要欢喜'或'你好'。",
    u: "在新约中使用74次。频繁命令在基督里欢喜。",
    e: "与χάρις（charis）= 恩典有关"
  },
  "G5495": {
    m: "手",
    d: "手；权能，权柄；行动，工作。",
    u: "在新约中使用177次。上帝的手，耶稣的手。",
    e: "基本词根"
  },
  "G5544": {
    m: "良善，仁慈",
    d: "行动中的良善，实际的仁慈；对他人有益、有帮助的品质。",
    u: "在新约中使用10次。加拉太书5:22中的圣灵果子。",
    e: "源自χρηστός（chrestos）= 良善的，有用的，仁慈的"
  },
  "G5547": {
    m: "基督，弥赛亚，受膏者",
    d: "受膏者，弥赛亚；耶稣作为应许救主的称号。",
    u: "在新约中使用529次。耶稣是基督。",
    e: "源自χρίω（chrio）= 膏抹"
  },
  "G5590": {
    m: "灵魂，生命",
    d: "生命之气，生命力；生命本身；不朽的灵魂。",
    u: "在新约中使用105次。属灵和永恒的生命。",
    e: "源自ψύχω（psucho）= 呼吸，使清新"
  },
  "H120": {
    m: "人，人类，亚当",
    d: "人，人类；人类；第一个人亚当。",
    u: "在旧约中使用562次。上帝造人。",
    e: "源自אָדֹם（adom）= 红色，或אֲדָמָה（adamah）= 土地"
  },
  "H160": {
    m: "爱，情感",
    d: "爱，情感；爱的行为。",
    u: "在旧约中使用40次。上帝对他子民的爱。",
    e: "源自אָהַב（ahab）= 爱"
  },
  "H216": {
    m: "光",
    d: "自然的或属灵的光；幸福，繁荣。",
    u: "在旧约中使用120次。'要有光！'",
    e: "源自אוֹר（or）= 发光"
  },
  "H430": {
    m: "上帝，诸神",
    d: "至高的上帝（以罗欣）；有时用于审判官或异教神明。",
    u: "在旧约中使用2606次。上帝的尊名复数形式。",
    e: "אֱלוֹהַּ（eloah）= 神的复数"
  },
  "H559": {
    m: "说，讲",
    d: "说，讲，宣告；命令，思想。",
    u: "在旧约中使用5316次。最常用的说话动词。",
    e: "基本词根"
  },
  "H776": {
    m: "地，国土",
    d: "地，土地；国家，地区；世界。",
    u: "在旧约中使用2504次。上帝所造的地。",
    e: "基本词根"
  },
  "H982": {
    m: "信靠，有信心",
    d: "信靠，有信心；安全。",
    u: "在旧约中使用120次。信靠耶和华。",
    e: "基本词根"
  },
  "H1004": {
    m: "房屋，住所",
    d: "房屋，居所；家庭，家族；圣殿。",
    u: "在旧约中使用2055次。耶和华的殿。",
    e: "源自בָּנָה（banah）= 建造"
  },
  "H1254": {
    m: "创造",
    d: "从无创造；塑造，制作；上帝专有的活动。",
    u: "在旧约中使用54次。上帝创造天地。",
    e: "基本词根"
  },
  "H1516": {
    m: "山谷，峡谷",
    d: "山谷，峡谷，深谷；平原。",
    u: "在旧约中使用60次。死荫的幽谷。",
    e: "基本词根"
  },
  "H1878": {
    m: "使肥壮，使丰满",
    d: "使肥壮，使肥胖；兴旺。",
    u: "在旧约中使用11次。你用油膏了我的头。",
    e: "源自דֶּשֶׁן（deshen）= 脂肪，灰烬"
  },
  "H1980": {
    m: "行走，去",
    d: "行走，去，来；生活，行事为人。",
    u: "在旧约中使用1554次。非常常用的运动动词。",
    e: "基本词根"
  },
  "H2617": {
    m: "慈爱，怜悯，信实",
    d: "良善，怜悯；对约的忠诚；坚定的爱。",
    u: "在旧约中使用248次。耶和华的慈爱。",
    e: "源自חָסַד（chasad）= 良善，怜悯"
  },
  "H2637": {
    m: "缺乏，需要",
    d: "缺乏，需要；减少，不足。",
    u: "在旧约中使用23次。我必不致缺乏（诗篇23:1）。",
    e: "基本词根"
  },
  "H2896": {
    m: "好的，善的",
    d: "好的，令人愉快的，优秀的；仁慈的，公义的。",
    u: "在旧约中使用559次。上帝看着是好的。",
    e: "基本词根"
  },
  "H3068": {
    m: "耶和华，永恒者",
    d: "上帝的专有名，神圣的四字神名YHWH。",
    u: "在旧约中使用6828次。最神圣的名字。",
    e: "源自הָיָה（hayah）= 是，存在"
  },
  "H3117": {
    m: "日子",
    d: "白天（与夜相对）；24小时的时间；时代，时期。",
    u: "在旧约中使用2301次。耶和华所定的日子。",
    e: "源自יוֹם（yowm）= 炎热"
  },
  "H3372": {
    m: "惧怕，害怕，敬畏",
    d: "惧怕，害怕；敬畏，尊重上帝。",
    u: "在旧约中使用335次。我不怕遭害。",
    e: "基本词根"
  },
  "H3563": {
    m: "杯，酒杯",
    d: "杯，酒杯；份，命运。",
    u: "在旧约中使用31次。我的福杯满溢。",
    e: "基本词根"
  },
  "H3820": {
    m: "心，思想",
    d: "心，情感的所在；思想，智慧，意志。",
    u: "在旧约中使用598次。人的心。",
    e: "基本词根"
  },
  "H3915": {
    m: "夜晚",
    d: "夜晚（与白天相对）；黑暗的时间。",
    u: "在旧约中使用234次。上帝分开昼夜。",
    e: "基本词根"
  },
  "H3966": {
    m: "非常，极其",
    d: "非常，极其，很多；有力地，快速地。",
    u: "在旧约中使用300次。甚好。",
    e: "源自מָאַד（ma'ad）= 众多"
  },
  "H4325": {
    m: "水，水域",
    d: "水，水域；雨水；洪水，海洋。",
    u: "在旧约中使用585次。创造的水。",
    e: "מַיִם（mayim）= 水的双数"
  },
  "H4999": {
    m: "草场，居所",
    d: "牧场之地，草原；居所，住处。",
    u: "在旧约中使用13次。在青草地上。",
    e: "源自נָאָה（na'ah）= 美丽的，合适的"
  },
  "H5148": {
    m: "引导，带领",
    d: "引导，带领，指引；安全地领路。",
    u: "在旧约中使用40次。他引导我（诗篇23:3）。",
    e: "基本词根"
  },
  "H5216": {
    m: "草场，耕地",
    d: "草原，牧场；耕地，田地。",
    u: "在旧约中使用2次。青草地。",
    e: "源自נִיר（niyr）= 耕地"
  },
  "H5315": {
    m: "灵魂，生命，人",
    d: "灵魂，生命，活物；人，自我；欲望，食欲。",
    u: "在旧约中使用753次。我的灵魂，我的生命。",
    e: "源自נָפַשׁ（naphash）= 呼吸"
  },
  "H5769": {
    m: "永恒，永远",
    d: "无限的时间，永恒；永远，永久。",
    u: "在旧约中使用439次。上帝永恒的爱。",
    e: "源自עָלַם（alam）= 隐藏，被隐藏"
  },
  "H6186": {
    m: "摆设，安排",
    d: "按顺序安排，摆设；预备桌子。",
    u: "在旧约中使用75次。你为我摆设筵席（诗篇23:5）。",
    e: "基本词根"
  },
  "H6213": {
    m: "做，完成",
    d: "做，制作，完成；行动，工作。",
    u: "在旧约中使用2632次。非常常用的动词。",
    e: "基本词根"
  },
  "H6664": {
    m: "公义，正直",
    d: "公义，正直，公平；信实。",
    u: "在旧约中使用119次。义路。",
    e: "源自צָדַק（tsadaq）= 公义"
  },
  "H6754": {
    m: "形象，样式",
    d: "形象，样式；形状，外观。",
    u: "在旧约中使用17次。人按照上帝的形象受造。",
    e: "源自צָלַל（tsalal）= 遮蔽，相似"
  },
  "H6757": {
    m: "死荫，深黑暗",
    d: "深沉的黑暗，死亡的黑暗；死亡的阴影。",
    u: "在旧约中使用18次。象征极度危险。",
    e: "源自צֵל（tsel）= 阴影 + מָוֶת（maveth）= 死亡"
  },
  "H6887": {
    m: "受困，仇敌",
    d: "被压制，受困苦；仇敌，敌人。",
    u: "在旧约中使用58次。在我敌人面前。",
    e: "基本词根"
  },
  "H7121": {
    m: "呼叫，呼喊，宣告",
    d: "呼叫，呼喊；命名；宣告，召集。",
    u: "在旧约中使用736次。求告耶和华的名。",
    e: "基本词根"
  },
  "H7200": {
    m: "看见，注视",
    d: "用眼睛看；察觉，理解；预备。",
    u: "在旧约中使用1311次。上帝看着是好的。",
    e: "基本词根"
  },
  "H7225": {
    m: "起初，初熟之物",
    d: "开始，起头；最好的，初熟的果子。",
    u: "在旧约中使用51次。'起初上帝创造……'",
    e: "源自רֹאשׁ（rosh）= 头，开始"
  },
  "H7257": {
    m: "躺下，安歇",
    d: "躺下，安歇；居住；孵化。",
    u: "在旧约中使用30次。他使我躺卧（诗篇23:2）。",
    e: "基本词根"
  },
  "H7291": {
    m: "追赶，追逐",
    d: "追赶，追逐；迫害；紧紧跟随。",
    u: "在旧约中使用144次。恩惠必随着我。",
    e: "基本词根"
  },
  "H7307": {
    m: "灵，气息，风",
    d: "气息，风；上帝或人的灵；心智倾向。",
    u: "在旧约中使用378次。上帝的灵。",
    e: "源自רוּחַ（ruach）= 吹气"
  },
  "H7462": {
    m: "牧养，放牧，喂养",
    d: "牧放羊群；作牧人；喂养，照顾。",
    u: "在旧约中使用173次。耶和华是我的牧者。",
    e: "基本词根"
  },
  "H7549": {
    m: "穹苍，天穹",
    d: "穹苍，天空的拱顶，天穹；天。",
    u: "在旧约中使用17次。水中间的穹苍。",
    e: "源自רָקַע（raqa）= 展开，锤打"
  },
  "H7626": {
    m: "杖，支派",
    d: "杖，棍；支派，家族分支。",
    u: "在旧约中使用190次。你的杖和你的竿。",
    e: "源自שָׁבַט（shabat）= 分枝"
  },
  "H7725": {
    m: "返回，归回，恢复",
    d: "返回，归回；恢复，更新；悔改。",
    u: "在旧约中使用1058次。使我的灵魂苏醒。",
    e: "基本词根"
  },
  "H7979": {
    m: "桌子",
    d: "吃饭用的桌子；陈设饼的桌子。",
    u: "在旧约中使用71次。预备的桌子。",
    e: "源自שָׁלַח（shalach）= 差遣，展开"
  },
  "H8064": {
    m: "诸天，天空",
    d: "诸天，天穹；上帝的居所；可见的天空。",
    u: "在旧约中使用420次。天和地。",
    e: "שָׁמַיִם（shamayim）= 高处的双数"
  },
  "H8414": {
    m: "空虚，无形，混沌",
    d: "荒野，荒凉；混沌，空虚，虚无。",
    u: "在旧约中使用20次。地是空虚混沌。",
    e: "源自תָּהָה（tahah）= 游荡"
  }
};

export default strongTranslationsZH;
